import React from 'react'
import Button from '../../shared/form/Button'

const Ambasador = props =>( 
  <div className="island">
  <h2>World Vision Child Ambassador</h2>
  <p>We are looking for individuals that would also like to actively campaign for the Filipino children. If you are one of them please fill out the page below and your donor care specialist will get in touch with you.</p>
  <form encType="multipart/form-data" onSubmit={props.submit}>

  <div className="form-item">
      <label htmlFor="edit-submitted-message">Why do you want to become a child ambassador? <span>*</span></label>
      <div className="form-textarea-wrapper">
        <textarea id="edit-submitted-message" cols="60" rows="5" className="form-textarea required form-control" name="why_ambassador" onChange={props.change}></textarea>
      </div>
    </div>


    <div className="form-item">
      <label htmlFor="edit-submitted-type-of-inquiry">Where did you learn about being a child ambassador? <span className="form-required" title="This field is required.">*</span></label>

      <div className="dropdown">
        <button className="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style={{ maxWidth: 'none', textAlign: 'left', width: 'auto' }}>
          {props.where_did_learn} <span className="caret"></span>
        </button>
        <ul className="dropdown-menu" aria-labelledby="dropdownMenu1">
          <li><a onClick={props.click('Online')} href="#Online">Online</a></li>
          <li><a onClick={props.click('My donor care specialist')} href="#My donor care specialist">My donor care specialist</a></li>
          <li><a onClick={props.click('Another child ambassador')} href="#Another child ambassador">Another child ambassador</a></li>
          <li><a onClick={props.click('Website')} href="#Website">Website</a></li>
        </ul>
      </div>
    </div>

 

    <div className="form-actions">
      <Button loading={props.loading}>Submit</Button>
    </div>
  </form>
</div>
)

Ambasador.defaultProps = {
  where_did_learn: 'Select '
}

export default Ambasador